import script from "./PlanFiscalCard.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanFiscalCard.vue?vue&type=script&setup=true&lang=js"

import "./PlanFiscalCard.vue?vue&type=style&index=0&id=28369d67&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28369d67"]])

export default __exports__